package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.element.QuestionElementDto
import com.exura.features.plandefinition.domain.model.element.QuestionElement
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Mapper for converting between QuestionElement domain model and DTO.
 * Implements PlanElementMappers for Firebase storage compatibility.
 */
class QuestionElementMappers : PlanElementMappers<QuestionElement, QuestionElementDto> {
    override fun toDto(model: QuestionElement): QuestionElementDto = QuestionElementDto(
        elementType = model.elementType.name,
        durationInMinutes = model.durationInMinutes,
        durationInDays = model.durationInDays(),
        relativeDay = model.relativeDay,
        title = model.title,
        question = model.question,
        options = model.options.map {
            QuestionElementDto.OptionDto(
                id = it.id,
                text = it.text,
                responseMessage = it.responseMessage
            )
        },
        imageUrl = model.imageUrl,
    )

    override fun toDomain(dto: QuestionElementDto, collection: CollectionReference?, id: String?): QuestionElement = QuestionElement(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        relativeDay = dto.relativeDay,
        title = dto.title,
        question = dto.question,
        options = dto.options.map {
            QuestionElement.Option(
                id = it.id,
                text = it.text,
                responseMessage = it.responseMessage
            )
        },
        imageUrl = dto.imageUrl,
        durationInMinutes = dto.durationInMinutes,
    )
}
